import ErrorHandler from '~/utils/api/errorHandler/ErrorHandler'

export default class TokenErrorHandler extends ErrorHandler {
  async check (...params: any[]): Promise<any> {
    await this.store.dispatch('auth/fillToken')
    return params[0](params[1])
  }
}
